import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { createWorkspacesSyncActions } from './workspaces.actions'
import { workspacesInitialState } from './workspaces.slice'
import type { WorkspacesStore } from './workspaces.type'

export const useWorkspacesStore = create<WorkspacesStore>()(
  devtools(
    subscribeWithSelector(
      immer((set) => ({
        ...workspacesInitialState,
        ...createWorkspacesSyncActions(set),
      }))
    ),
    {
      name: StoreDevtoolsName.Workspaces,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
